// Angular
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

// Partials
import { PartialsModule } from '../../partials/partials.module';
// Pages
import { CoreModule } from '../../../core/core.module';

import { MaterialModule } from '../../pages/material.module';
import { EvaluationFormItemComponent } from './evaluation-form-item.component';
import { FileUploaderModule } from '../file-uploader/file-uploader.module';
import { ConversationManagerModule } from '../conversation-manager/conversation-manager.module';
import { TranslateModule } from '@ngx-translate/core';
import {DragDropModule} from '@angular/cdk/drag-drop';
import { RecordTypeQuestionComponent } from '../record-type-question/record-type-question.component';

@NgModule({
	declarations: [
        EvaluationFormItemComponent,
        RecordTypeQuestionComponent
	],
	exports: [
		MaterialModule,
        EvaluationFormItemComponent,
        PartialsModule
		],
  imports: [
    PartialsModule,
    CoreModule,
    CommonModule,
    MaterialModule,
    TranslateModule.forChild(),
    FileUploaderModule,
    ConversationManagerModule,
    DragDropModule
  ],
	providers: []
})
export class EvaluationFormItemModule {
}
